import { DashboardColumnStatus, StatusValue } from '@/shared';

export const convertStatusIntoDashboardStatus = (
  status: StatusValue,
): DashboardColumnStatus => {
  const dashboardStatusKey = Object.entries(statusMapper).find(
    ([, statusList]) => statusList.includes(status),
  )![0];

  return Number(dashboardStatusKey) as DashboardColumnStatus;
};

export const convertDashboardStatusIntoStatus = (
  status: DashboardColumnStatus,
): StatusValue[] => {
  return statusMapper[status] ?? [];
};

const statusMapper: Record<DashboardColumnStatus, StatusValue[]> = {
  [DashboardColumnStatus.Submitted]: [StatusValue.Submitted],
  [DashboardColumnStatus.InEvaluation]: [
    StatusValue.Analysis,
    StatusValue.Blocked,
    StatusValue.Quoted,
  ],
  [DashboardColumnStatus.InExecution]: [
    StatusValue.OnHold,
    StatusValue.ToDo,
    StatusValue.Accepted,
    StatusValue.InProgress,
    StatusValue.InQA,
    StatusValue.Pending,
  ],
  [DashboardColumnStatus.Concluded]: [
    StatusValue.Done,
    StatusValue.Canceled,
    StatusValue.Rejected,
  ],
};
